import React, { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import BookSeries from "./components/BookSeries";
import Characters from "./components/Characters";
import AboutAuthor from "./components/AboutAuthor";
import BuySection from "./components/BuySection";
import ContactNewsletter from "./components/ContactNewsletter";
import Footer from "./components/Footer";
import AskPixie from "./components/AskPixie";
import PaymentStatusBanner from "./components/PaymentStatusBanner";
import PixieNameQuiz from "./components/PixieNameQuiz";
import PortalIntro from "./components/PortalIntro";
import BackgroundMusic from "./components/BackgroundMusic";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/books`);
        setBooks(res.data?.books || []);
      } catch (e) {
        console.error("Failed to load books", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="App min-h-screen text-white">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(20, 50, 35, 0.85)",
            border: "1px solid rgba(255, 215, 0, 0.3)",
            color: "#FDFBF7",
            backdropFilter: "blur(12px)",
          },
        }}
      />
      <PortalIntro />
      <Navbar />
      <PaymentStatusBanner />
      <Hero />
      <BookSeries books={books} loading={loading} />
      <Characters />
      <PixieNameQuiz />
      <AboutAuthor />
      <BuySection books={books} />
      <ContactNewsletter />
      <Footer />
      <AskPixie />
      <BackgroundMusic />
    </div>
  );
}

export default App;
